import React, { useState, useMemo } from 'react';
import { Button } from 'react-bootstrap';

import Table from 'components/common/Table';
import PicklistShipmentDetailPanel from './PicklistShipmentDetailPanel';

import { picklistApi } from 'api';

import { PICKLIST_DETAIL_SHIPMENT_COLUMNS } from 'constants/picklist';

const PicklistShipments = ({ picklistId }) => {
  const [showDetail, setShowDetail] = useState(false);
  const [selectedShipmentInfo, setSelectedShipmentInfo] = useState(null);

  const handleViewDetail = async shipmentId => {
    try {
      const detail = await picklistApi.getShipmentDetailOfPicklist(
        picklistId,
        shipmentId,
      );
      setSelectedShipmentInfo(detail);
      setShowDetail(true);
    } catch (err) {
      console.error('Failed to fetch shipment detail:', err);
    }
  };

  const handleCloseDetail = () => {
    setShowDetail(false);
    setSelectedShipmentInfo(null);
  };

  const extendedColumns = useMemo(() => {
    const detailColumn = {
      accessorKey: 'actions',
      header: '',
      meta: {
        headerProps: { className: 'text-center' },
        cellProps: { className: 'text-center' },
      },
      cell: ({ row: { original } }) => {
        return (
          <Button
            size="sm"
            variant="falcon-default"
            onClick={() => handleViewDetail(original.id)}
          >
            View
          </Button>
        );
      },
    };

    return [...PICKLIST_DETAIL_SHIPMENT_COLUMNS, detailColumn];
  }, []);

  return (
    <>
      <Table
        title={`Picklists #${picklistId} Shipments`}
        apiService={picklistApi}
        columns={extendedColumns}
        fetchConfig={{
          method: 'getShipmentsOfPicklist',
          enablePagination: true,
        }}
        resourceId={picklistId}
        initialPageSize={25}
        initialFilter={{ tab: 'shipments' }}
      />

      <PicklistShipmentDetailPanel
        show={showDetail}
        onHide={handleCloseDetail}
        shipmentDetail={selectedShipmentInfo}
      />
    </>
  );
};

export default PicklistShipments;
